import { render, staticRenderFns } from "./MorbidityPage.vue?vue&type=template&id=79e457de&scoped=true"
import script from "./MorbidityPage.vue?vue&type=script&lang=js"
export * from "./MorbidityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e457de",
  null
  
)

export default component.exports